import React, {Component} from 'react';
import debounce from 'utils/debounce';

import {breakpoints} from 'styles/globals';

function collapseNavBar(Context) {
	class CollapseNavBar extends Component {
		constructor(props) {
			super(props);
			this.state = {
				isCollapsed: false,
			};
			this.collapseNavbar = this.collapseNavbar.bind(this);
			this.handleScroll = this.handleScroll.bind(this);
		}

		collapseNavbar() {
			const currentScrollY =
				document.body.scrollTop || document.documentElement.scrollTop;

			this.setState({
				isCollapsed: currentScrollY > 20,
			});

			this.handlingScrollUpdate = false;
		}

		handleScroll() {
			if (!this.handlingScrollUpdate && this.hasStackedNavbar) {
				this.handlingScrollUpdate = true;
				requestAnimationFrame(this.collapseNavbar);
			}
		}

		UNSAFE_componentWillMount() {
			this.handlingScrollUpdate = false;

			this.hasStackedNavbar = window.matchMedia(
				`(max-width: ${breakpoints.s})`
			).matches;
		}

		componentDidMount() {
			this.debouncedScrollHandler = debounce(() => {
				this.handleScroll();
			}, 50);

			window.addEventListener('scroll', this.debouncedScrollHandler);
		}

		componentWillUnmount() {
			window.removeEventListener('scroll', this.debouncedScrollHandler);
		}

		render() {
			return (
				<Context {...this.props} isCollapsed={this.state.isCollapsed} />
			);
		}
	}

	return CollapseNavBar;
}

export default collapseNavBar;
